import { createRoute } from '@tanstack/react-router';
import { onboardingParentRoute } from 'pages/shared/Onboarding/onboardingParentRoute';

export const onboardingPharmacistOrLabRoute = createRoute({
  getParentRoute: () => onboardingParentRoute,
  path: '/pharmacist_or_lab',
}).lazy(() =>
  import('pages/shared/Onboarding/PharmacistOrLab/PharmacistOrLabPage').then((d) => d.Route)
);
